<div class="panel panel-blue info-container" *ngIf="mapViewRef">
    <h4 class="trailer-half">
        <ng-container *ngIf="!editTitle">
            {{ mapViewRef.mapcoreViewProps.name }}
            <button *ngIf="editable" type="button" class="btn btn-small icon-ui-edit icon-only-btn" (click)="toggleEdit()"></button>
        </ng-container>
        <div *ngIf="editTitle">
            <input type="text" [(ngModel)]="mapName" class="inline-block" style="width: calc(100% - 96px);" />
            <button type="button" class="btn btn-small icon-ui-check-mark icon-only-btn" (click)="saveMapName()"></button>
            <button type="button" class="btn btn-small icon-ui-close icon-only-btn" (click)="toggleEdit()"></button>
        </div>
        <span class="right" *ngIf="showOptionMenu; else exitCompactLegend">
            <slot name="option-menu" #optionMenu></slot>
        </span>
        <ng-template #exitCompactLegend>
            <button type="button" class="btn btn-transparent exit-btn icon-ui-close icon-ui-white icon-only-btn right" tabindex="0" (click)="exitCompactView()"></button>
        </ng-template>
    </h4>
    <div class="trailer-0" *ngIf="showDescription">
        <span class="white-text-hover description-link" *ngIf="collapseDescription" (click)="showHideInfo()">
            Show map
            description
        </span>
        <span class="white-text-hover description-link" *ngIf="!collapseDescription" (click)="showHideInfo()">
            Hide map
            description
        </span>
        <br>
        <p class="description-text" *ngIf="!collapseDescription">{{ mapViewRef.mapcoreViewProps.description }}</p>
    </div>
    <hr [ngClass]="{ 'compact': _isCompact }">
    <slot name="content"></slot>
</div>
